import httpService from "..";

export const searchFuneralInvoicesApi = async (groupId: string, search: string) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/funeral/invoice/group/${groupId}/search?search=${search}`,
    "get"
  );
};

export const getFuneralInvoiceApi = async (invoiceId: string) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/funeral/invoice/${invoiceId}`,
    "get"
  );
};

export const getCompanyFuneralInvoicesApi = async (groupId: string) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/funeral/invoice/group/${groupId}`,
    "get"
  );
};

export const addFuneralInvoiceApi = async (data: {}, groupId: string) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/funeral/invoice?groupId=${groupId}`,
    "post",
    data
  );
};

export const editFuneralInvoiceApi = async (id: string, data: any) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/funeral/invoice/${id}`,
    "patch",
    data
  );
};
